import {
  APIgetShare,
  APIgetShareFiles,
  APIgetShareCollections,
  APIcreateShareDownload,
  APIlikeShareFile,
  APIunlikeShareFile,
  APIlikeShareCollection,
  APIunlikeShareCollection,
  APIdeleteShare,
  APIauthShare,
  APIgetShareFileStatuses,
  APIupdateShareFile,
  APIfetchShareDetails,
  APIfetchAcceptedTermsOfService,
} from '../api/Shares';
import {
  getFiles,
  setFilesTotal,
  setFilesLoading,
  setFilesEnd,
  setFilesParams,
  addDownloadRequest,
  updateFilesOnFilesList,
  updateFilesLikesOnFilesList,
  getFileStatuses,
} from './Files';
import {
  getCollections,
  setCollectionsLoading,
  setCollectionsEnd,
  setCollectionsParams,
  updateCollectionLikesOnCollectionsList,
} from './Collections';

export const SET_SHARE_LOADING = 'SET_SHARE_LOADING';
export const SET_SHARE_AUTH_LOADING = 'SET_SHARE_AUTH_LOADING';
export const SET_SHARE_FILES_LOADING = 'SET_SHARE_FILES_LOADING';
export const SET_SHARE_NOT_FOUND = 'SET_SHARE_NOT_FOUND';
export const SET_SHARE_PROVIDE_PASSWORD = 'SET_SHARE_PROVIDE_PASSWORD';
export const SET_SHARE_PASSWORD_ERROR = 'SET_SHARE_PASSWORD_ERROR';
export const GET_SHARE = 'GET_SHARE';

export const setShareLoading = status => ({
  type: SET_SHARE_LOADING,
  loading: status,
});

export const setShareAuthLoading = status => ({
  type: SET_SHARE_AUTH_LOADING,
  loading: status,
});

export const setShareFilesLoading = status => ({
  type: SET_SHARE_FILES_LOADING,
  loading: status,
});

export const setShareNotFound = status => ({
  type: SET_SHARE_NOT_FOUND,
  status,
});

export const setShareProvidePassword = providePassword => ({
  type: SET_SHARE_PROVIDE_PASSWORD,
  providePassword,
});

export const setSharePasswordError = passwordError => ({
  type: SET_SHARE_PASSWORD_ERROR,
  passwordError,
});

export const getShare = share => ({
  type: GET_SHARE,
  share,
});

export const authShare = (shareId, data) => (dispatch) => {
  dispatch(setShareAuthLoading(true));
  return APIauthShare(shareId, data)
    .then((response) => {
      dispatch(setShareProvidePassword(false));
      dispatch(setSharePasswordError(false));
      return response.data;
    })
    .catch((error) => {
      dispatch(setShareProvidePassword(true));
      dispatch(setSharePasswordError(true));
      return error.response;
    })
    .finally(() => {
      dispatch(setShareAuthLoading(false));
    });
};

export const fetchShare = (shareId, params = {}) => (dispatch) => {
  dispatch(setShareLoading(true));
  return APIgetShare(shareId, params)
    .then((response) => {
      dispatch(getShare(response.data));
      dispatch(setShareLoading(false));
      return response.data;
    })
    .catch((error) => {
      if (error.response?.status === 404) {
        dispatch(setShareNotFound(true));
      }
      return error.response;
    });
};

export const fetchFiles = () => (dispatch, getState) => {
  dispatch(setFilesLoading(true));

  const state = getState();

  if (state.Files.end) {
    return false;
  }

  const params = { ...state.Files.params };
  params.page += 1;

  const { collectionUuid } = state.Files;
  if (collectionUuid) {
    params.collectionUuid = collectionUuid;
  }

  delete params.perPage;
  params.per_page = 30;

  return APIgetShareFiles(state.Shares.share.uuid || null, params)
    .then((response) => {
      const { data } = response;
      if (data && data.data) {
        dispatch(getFiles(data.data.data));
        if (data.meta.current_page === data.meta.last_page) {
          dispatch(setFilesEnd(true));
        }
        dispatch(setFilesParams({ page: data.meta.current_page }));
        dispatch(setFilesTotal(data.meta.total));
        dispatch(setFilesLoading(false));
        return data;
      }
      return response;
    })
    .catch(error => (error));
};

export const fetchCollections = () => (dispatch, getState) => {
  dispatch(setCollectionsLoading(true));

  const state = getState();

  if (state.Collections.end) {
    return false;
  }

  const params = { ...state.Collections.params };
  params.page += 1;

  const { collectionUuid } = state.Files;
  if (collectionUuid) {
    params.collectionUuid = collectionUuid;
  }

  return APIgetShareCollections(state.Shares.share.uuid || null, params)
    .then((response) => {
      const { data } = response;
      if (data && data.data) {
        dispatch(getCollections(data.data.data, data.meta.total));
        if (data.meta.current_page === data.meta.last_page) {
          dispatch(setCollectionsEnd(true));
        }
        dispatch(setCollectionsParams({ page: data.meta.current_page }));
        dispatch(setCollectionsLoading(false));
        return data;
      }
      return response;
    })
    .catch(error => (error));
};

export const createShareDownloadRequest = (shareUuid, { files, fileSizes }) => dispatch => (
  APIcreateShareDownload(shareUuid, { files, file_sizes: fileSizes })
    .then((response) => {
      if (response.data && response.data.uuid) {
        dispatch(addDownloadRequest(response.data.uuid));
        return response.data;
      }
      return response.data;
    })
    .catch(error => (error))
);

export const fetchCollectedDetails = (shareUuid, page, perPage) => (
  APIfetchShareDetails(shareUuid, { page, per_page: perPage })
    .then(response => response.data)
    .catch(error => (error))
);

export const fetchAcceptedTermsOfService = (shareUuid, page, perPage) => (
  APIfetchAcceptedTermsOfService(shareUuid, { page, per_page: perPage })
    .then(response => response.data)
    .catch(error => (error))
);

export const likeShareFile = (shareUuid, fileUuid) => dispatch => (
  APIlikeShareFile(shareUuid, fileUuid)
    .then((response) => {
      if (response.data) {
        dispatch(updateFilesLikesOnFilesList([response.data]));
        return response.data;
      }
      return response;
    })
    .catch(error => (error))
);

export const unlikeShareFile = (shareUuid, fileUuid) => dispatch => (
  APIunlikeShareFile(shareUuid, fileUuid)
    .then((response) => {
      if (response.data) {
        dispatch(updateFilesLikesOnFilesList([response.data]));
        return response.data;
      }
      return response;
    })
    .catch(error => (error))
);

export const switchShareFileLike = (shareUuid, file) => (dispatch) => {
  if (file.liked) {
    return dispatch(unlikeShareFile(shareUuid, file.uuid));
  }
  return dispatch(likeShareFile(shareUuid, file.uuid));
};

export const likeShareCollection = (shareUuid, collectionUuid) => dispatch => (
  APIlikeShareCollection(shareUuid, collectionUuid)
    .then((response) => {
      if (response.data) {
        dispatch(updateCollectionLikesOnCollectionsList(response.data));
        return response.data;
      }
      return response;
    })
    .catch(error => (error))
);

export const unlikeShareCollection = (shareUuid, collectionUuid) => dispatch => (
  APIunlikeShareCollection(shareUuid, collectionUuid)
    .then((response) => {
      if (response.data) {
        dispatch(updateCollectionLikesOnCollectionsList(response.data));
        return response.data;
      }
      return response;
    })
    .catch(error => (error))
);

export const switchShareCollectionLike = (shareUuid, collection) => (dispatch) => {
  if (collection.liked) {
    return dispatch(unlikeShareCollection(shareUuid, collection.uuid));
  }
  return dispatch(likeShareCollection(shareUuid, collection.uuid));
};

export const deleteShare = shareUuid => () => (
  APIdeleteShare(shareUuid)
    .then(response => (response.data))
);

export const fetchShareFileStatuses = (shareUuid) => (dispatch) => (
  APIgetShareFileStatuses(shareUuid)
    .then((response) => {
      dispatch(getFileStatuses(response.data));
      return response.data;
    })
    .catch(error => (error))
);

export const updateShareFile = (shareUuid, fileUuid, file) => (dispatch) => (
  APIupdateShareFile(shareUuid, fileUuid, file)
    .then((response) => {
      dispatch(updateFilesOnFilesList([response.data]));
      return response.data;
    })
    .catch(error => Promise.reject(error))
);
